import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Breadcrumbs as MuiBreadcrumbs, Link, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  return (
    <MuiBreadcrumbs 
      separator={<NavigateNextIcon fontSize="small" />} 
      sx={{ mb: 2 }}
    >
      <Link 
        component={RouterLink} 
        to="/" 
        color="inherit"
        underline="hover"
      >
        Home
      </Link>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return isLast ? (
          <Typography color="text.primary" key={item.label}>
            {item.label}
          </Typography>
        ) : (
          <Link
            component={RouterLink}
            to={item.path || '#'}
            color="inherit"
            key={item.label}
            underline="hover"
          >
            {item.label}
          </Link>
        );
      })}
    </MuiBreadcrumbs>
  );
};
